import { Component, inject, OnInit } from '@angular/core';

import { MapOptionComponent } from '../map-option.component';
import { MapOptionLayerService } from './map-option-layers.service';
import { MetricsOptionsService, MetricsService } from 'app/services';

export interface MapOptionLayer {
    title: string;
    id: string;
    visible: boolean;
    action: (layer: MapOptionLayer) => void;
    meta?: { [key: string]: any }; // allow maps to store library specific information if needed
}

export interface MapOptionLayerConfig {
    baseLayers : MapOptionLayer[];
    overlays: MapOptionLayer[];
    supportsMarkerClustering: boolean;
    showLabelsToggle: boolean;
}

@Component({
    styleUrls: ['./map-option-layers.component.scss'],
    templateUrl: './map-option-layers.component.html',
})
export class MapOptionLayerComponent implements MapOptionComponent<MapOptionLayerConfig>, OnInit {
    
    static ID = 'map-option-layers-component';
    static ICON = 'layer-group';
    static TITLE = 'LEAFLET.MAP_OPTIONS.LAYERS';

    data: MapOptionLayerConfig;

    clustering = true;
    labels = true;


    private metrics = inject(MetricsService);
    private metricsOptions = inject(MetricsOptionsService);

    constructor(private layerService: MapOptionLayerService) {}

    ngOnInit(): void {
        this.clustering = this.layerService.markerClustering;
        this.labels = this.layerService.labels;
    }

    clickLayer(event: MouseEvent, layer: MapOptionLayer) {
        layer.visible = (event.target as HTMLInputElement).checked;
        layer.action(layer);

        this.captureAnalytics();
    }

    toggleClustering() {
        this.layerService.toggleMarkerClustering();
        this.captureAnalytics();
    }

    toggleLabels() {
        this.layerService.toggleLabels();
        this.captureAnalytics();
    }

    private captureAnalytics() {
        const isLiveMap = this.metricsOptions.isPage('live_map');
        const isTripHistory = this.metricsOptions.isPage('trip_history');

        if (!isLiveMap && !isTripHistory) return;

        const activeItems = [
            ...this.data.baseLayers.filter(l => l.visible).map(l => l.id),
            ...this.data.overlays.filter(l => l.visible).map(l => l.id),
            ...(this.data.showLabelsToggle && this.layerService.labels ? ['Labels'] : []),
            ...(this.data.supportsMarkerClustering && this.layerService.markerClustering ? ['Marker Clustering'] : [])
        ].join(', ');

        this.metrics.capture('ui_change', {
            screen: this.metricsOptions.getScreenFromUrl(),
            source: 'map_option_menu',
            type: 'map_layers',
            value: activeItems,
        });
    }
}

